@for (dayOfWeek of daysOfWeek; let idx = $index; track idx) {
    <fieldset class="tag">
        <legend class="header">
            <dvlib-print-day-of-week [dayOfWeek]="dayOfWeek"/>
        </legend>
        <ng-container *ngTemplateOutlet="templateRef(); context:{$implicit: dayOfWeek, index: idx}"/>
    </fieldset>
}
